import { useTheme } from '../../contexts/ThemeContext'

interface FormInputProps {
  label: string
  name: string
  type: string
  value: string
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void
  placeholder?: string
  required?: boolean
  minLength?: number
}

export default function FormInput({
  label,
  name,
  type,
  value,
  onChange,
  placeholder,
  required = false,
  minLength
}: FormInputProps) {
  const { theme } = useTheme()

  return (
    <div>
      <label className={`block font-semibold mb-2 ${theme === 'dark' ? 'text-gold-400' : 'text-gold-500'}`}>
        {label}
      </label>
      <input
        type={type}
        name={name}
        value={value}
        onChange={onChange}
        required={required}
        minLength={minLength}
        className={`w-full px-4 py-3 rounded-lg border-2 focus:outline-none transition
          ${theme === 'dark' 
            ? 'bg-black border-gold-500 text-white focus:border-gold-400 placeholder-gray-500' 
            : 'bg-white border-gold-400 text-gray-900 focus:border-gold-500 placeholder-gray-400'
          }`}
        placeholder={placeholder}
      />
    </div>
  )
}

